import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AddEditMotorValueComponent } from './add-edit-motor-value/add-edit-motor-value.component';
import { DocumentService } from '@app/shared/services';
import { FetchAttributeDataSubject } from '../add-finacial-attribute/attribute-subject.service';
import { AddApiRapidValueService } from '../add-api-rapid-value.service';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'add-api-rapid-motor-value',
  templateUrl: './add-api-rapid-motor-value.component.html',
  styleUrls: ['./add-api-rapid-motor-value.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddApiRapidMotorValueComponent implements OnInit, OnDestroy {
  isDataLoading = true;
  @Output() updateActionItemVehicle = new EventEmitter<string>();

  apiMotorValueList = [];
  allowEditPermission = true;
  @Input() mode;
  @Input() currentFormId;
  @Input() templateId = null;
  @Input() rapidAPISetupData;
  selectedFileList = [];
  subscription = new Subscription();
  formSetupData;
  private AddApiRapidValueService = inject(AddApiRapidValueService);
  constructor(
    private dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private _documentService: DocumentService,
    private attributeSubject: FetchAttributeDataSubject
  ) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  editMotor(motor) {
    this.addEditMotorData();
  }
  addEditMotorData() {
    this.formSetupData = this.rapidAPISetupData.find((r) => r.sub_type === 'VehicleDatabase');
    const childDialog = this.dialog.open(AddEditMotorValueComponent, {
      height: '100%',
      data: {
        currentFormId: this.currentFormId,
        is_edit: this.apiMotorValueList && this.apiMotorValueList.length ? true : false,
        apiMotorValueList: this.apiMotorValueList[0],
        formSetupData: this.formSetupData,
        templateId: this.templateId,
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      childDialog.afterClosed().subscribe(
        (data) => {
          this.isDataLoading = true;
          this.AddApiRapidValueService.addEditMotorSubjectData.next(null);

          if (data?.success) {
            this.getVehicleData();
            this.attributeSubject.handleFetchData(true);
            this.updateActionItemVehicle.emit('complete');
          } else {
            // please check this call, I enclosed it in else block
            this.getVehicleData();
          }
        },
        (error) => {
          this.isDataLoading = false;
          console.error('Dialog close error:', error);
        }
      )
    );
  }

  ngOnInit(): void {
    this.subscription.add(
      this.AddApiRapidValueService.addEditMotorSubjectData.subscribe((data) => {
        if (data === 'addEditMotorData') {
          this.addEditMotorData();
        }
      })
    );
    this.getVehicleData();
  }

  getVehicleData() {
    this.subscription.add(
      this._documentService.getVaultFormRapidIntegration(this.currentFormId).subscribe((res) => {
        this.apiMotorValueList = [];
        this.AddApiRapidValueService.vehicleDataSubjectData.next(this.apiMotorValueList);
        if (res?.length && res.filter((x) => x.type == 'vehicleDatabase')?.length) {
          let element = res.filter((x) => x.type == 'vehicleDatabase')[0];
          element.payload = JSON.parse(element.payload);
          try {
            element.response = JSON.parse(element.response);
          } catch (error) {}
          element.setting = JSON.parse(element.setting);
          this.apiMotorValueList.push(element);
          this.AddApiRapidValueService.vehicleDataSubjectData.next(this.apiMotorValueList);
          this.AddApiRapidValueService.setPropertyDataFromLiveFeeds(element, this.templateId);
        }
        this.isDataLoading = false;

        this.cd.detectChanges();
      })
    );
  }
}
